module.exports = __webpack_public_path__ + "static/media/shutterstock_2002025357.8d38b25a.jpg";